import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUsers,
  selectLoading,
  selectUsers
} from '../../features/users/usersSlice'

import { Button, Card, Form, Input, Space, Table, message } from 'antd'
import { Layout } from '../../components/Layout'
import { Spinner } from '../../components/Spinner'

import {
  giveS3Access,
  selectAwsLoading,
  updateS3Access,
  selectAwsSuccess,
  revokeS3Access
} from '../../features/aws/awsSlice'
import { IS_ADMIN } from '../../constants';

const tailItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
    },
    md: {
      offset: 6,
      span: 12
    }
  }
}

const COLUMNS = [
  {
    dataIndex: 'email',
    title: 'Email',
    width: 120
  },
  {
    dataIndex: 'first_name',
    title: 'First Name',
    width: 150
  },
  {
    dataIndex: 'last_name',
    title: 'Last Name',
    width: 150
  },
  {
    dataIndex: 'iam_username',
    title: 'IAM username',
    width: 150
  },
  {
    dataIndex: 's3_filepath',
    title: 'S3 FolderPath',
    width: 150
  }
]

export const Admin = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch])

  const { users } = useSelector(selectUsers);
  const profileLoading = useSelector(selectLoading);
  const [selectedRowKey, setSelectedRowKey] = useState(0);
  const [form] = Form.useForm();
  const awsLoading = useSelector(selectAwsLoading);
  const awsSuccess = useSelector(selectAwsSuccess);
  const [disableUsername, setDisableUsername] = useState(false)
  const [updateS3Path, setUpdateS3Path] = useState(false)
  const isAdmin = localStorage.getItem(IS_ADMIN)

  useEffect(() => {
    if(awsSuccess) {
      message.success(awsSuccess);
      dispatch(fetchUsers());
      form.setFieldValue("username", '')
      form.setFieldValue("folderName", '')
      form.setFieldValue("email", '')
      setSelectedRowKey('')
    } 
  }, [awsLoading])

  useEffect(() => {
    form.setFieldValue("email", selectedRowKey[0])
    setDisableUsername(false);
    setUpdateS3Path(false);
    if(users && users.length > 0) {
      const user = users.filter(user => user.email === selectedRowKey[0])
      if(user && user.length > 0 && user[0].iam_username) {
        form.setFieldValue("username", user[0].iam_username)
        form.setFieldValue("folderName", user[0].s3_filepath)
        setDisableUsername(true);
        setUpdateS3Path(true);
      }
    }
  }, [selectedRowKey])

  if (profileLoading ) return <Spinner />

  const onSubmit = async ({ email, username, folderName }) => {
    console.log("on submit")
    if(updateS3Path) {
      try {
        if(folderName[0] === '/'){ 
        const folder = folderName.replace('/','')
        dispatch(updateS3Access(email, "policy_" + username, folder))
      } else {
        dispatch(updateS3Access(email, "policy_" + username, folderName))
      }
        
      } catch (e) {
        message.error(e.message);
      } 
    } else {
      try {
        console.log("on submit giveS3Access")
        if(folderName[0] === '/'){ 
          const folder = folderName.replace('/','')
          dispatch(giveS3Access(email, username, "policy_" + username, folder))
        } else {
          dispatch(giveS3Access(email, username, "policy_" + username, folderName))
        }
       
      } catch (e) {
        message.error(e.message);
      } 
    }
    
  }

  const removeS3Access = async (email) => {
      try {
        dispatch(revokeS3Access(email))
      } catch (e) {
        message.error(e.message);
      } 
    
  }

  const onSelectChange = (selectedRowKeys) => {
    if (selectedRowKeys.length > 1) {
      const lastSelectedRowIndex = [...selectedRowKeys].pop()
      setSelectedRowKey(lastSelectedRowIndex)
    }
      setSelectedRowKey(selectedRowKeys)
    
  }

  return (
    <Layout.Content>
      {console.log('isAdmin', isAdmin, isAdmin !== 'null' && isAdmin !== 'false')}
      {!(isAdmin === 'null' || isAdmin === 'false') ? 
      <Space direction="vertical" size={50} style={{ display: 'flex' }}>
        <Card type="inner" title="Users">
          <Table columns={COLUMNS}
            dataSource={users}
            rowKey={(record) => `${record.email}`}
            pagination={{ hideOnSinglePage: true }}
            scroll={{ x: 'max-content' }}
            rowSelection={{
              selectedRowKey,
              onChange: onSelectChange,
              type: 'radio'
            }}
          />
        </Card>
        <Card type="inner" title="Give S3 bucket folder access">
          <Form 
           form={form}
           name="s3-access-form"
           onFinish={onSubmit}>
          <Form.Item
            label="Email"
            name="email"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
            rules={[
              { required: true, message: 'Please select a user.' },
            ]}
          >
            <Input placeholder="Email"  disabled/>
          </Form.Item>
          <Form.Item
            label="Username"
            name="username"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
            rules={[
              {required: true, message: 'Please enter a username.'},
              {max: 64, message : 'Username can only contain maximum 64 characters'}
            ]}
          >
            <Input placeholder="Username" disabled={awsLoading || profileLoading || disableUsername } />
          </Form.Item>
          <Form.Item
            label="Folder Path"
            name="folderName"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
            rules={[
              { required: true, message: 'Please enter a folder path.' },
            ]}
          >
            <Input placeholder="Folder Path e.g home/test/" disabled={awsLoading || profileLoading}/>
          </Form.Item>
          <Form.Item {...tailItemLayout} style={{ textAlign: 'center'}}>
            <Button type="primary" htmlType="submit" disabled={awsLoading || profileLoading}>{updateS3Path? 'Update S3 path':'Assign S3 access'}</Button>

            <Button onClick={(e) => {
              e.preventDefault()
              if(selectedRowKey[0]) {
                  removeS3Access(selectedRowKey[0]); 
                }
              }} style={{marginLeft : '10px'}} disabled={awsLoading || profileLoading}>{'Revoke S3 access'}</Button>
          </Form.Item>
          </Form>
        </Card>
      </Space> : <Space><div className="c-header__inner">
        <div className="c-header__col-main">
          <div className="c-header__subtitle">
              This user does not have access to this page
          </div>
        </div>
        </div></Space> }
    </Layout.Content>
  )
}
